import {
    REQUEST_REGULAR_EXPENSES,
    RECEIVE_REGULAR_EXPENSES,
    UPDATE_REGULAR_EXPENSES,
    ERROR_REGULAR_EXPENSES
} from '../types'
import {fetchUrl} from '../../constants/constants'
import {requestItem, receiveItem, failedItem, updateItem} from "../actions"
import fetchErrorCtrl from "../../helpers/fetchErrorCtrl"
import shouldFetch from "../../helpers/shouldFetch"
import axios from 'axios'
import prepareFilters from "../../helpers/prepareFilters";

function request() {
    return {
        type: REQUEST_REGULAR_EXPENSES
    };
}

export function receive(data) {
    return {
        type: RECEIVE_REGULAR_EXPENSES,
        payload: data
    }
}

function failed(data) {
    return {
        type: ERROR_REGULAR_EXPENSES,
        errors: data
    }
}

function update(data, id, updateType) {
    return {
        type: UPDATE_REGULAR_EXPENSES,
        id,
        payload: data,
        updateType
    }
}

export function getRegularExpenses(params = {}, force = false) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().regularExpenses, !force)) {
            dispatch(request())
            return axios({
                method: 'GET',
                url: fetchUrl + 'regular-expenses',
                params: prepareFilters(params, getState(), "regularExpenses")
            }).then(res => {
                dispatch(receive(res.data.data))
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failed(errors))
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function getRegularExpense(id) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem('regular-expense'))
            return axios({
                method: 'GET',
                url: fetchUrl + 'regular-expenses/' + id
            }).then(res => {
                dispatch(receiveItem(res.data.data))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function createRegularExpense(data) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem())
            return axios({
                method: 'POST',
                url: fetchUrl + 'regular-expenses',
                data
            }).then(res => {
                dispatch(receiveItem({}, 'message.item_created'))
                dispatch(update(res.data.data, false, 'create'))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function updateRegularExpense(data, id) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem('regular-expense'))
            return axios({
                method: 'PUT',
                url: fetchUrl + 'regular-expenses/' + id,
                data
            }).then(res => {
                dispatch(receiveItem(res.data.data, 'message.item_updated'))
                dispatch(update(res.data.data, id, 'update'))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function deleteRegularExpense(id) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem())
            return axios({
                method: 'DELETE',
                url: fetchUrl + 'regular-expenses/' + id
            }).then(res => {
                dispatch(receiveItem({}, 'message.item_deleted'))
                dispatch(update(res.data.data, id, 'delete'))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}